import React from 'react';
import { Container } from './ui/Container';
import { Button } from './ui/Button';
export function Header() {
  const scrollToPartner = () => {
    const element = document.getElementById('partner');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <header className="w-full py-6 bg-white border-b border-[#E5E5E0]" data-id="element-28">
      <Container className="flex items-center justify-between" data-id="element-29">
        <div className="flex items-center gap-3" data-id="element-30">
          <img src="https://cdn.magicpatterns.com/uploads/hfTK3ieARsQcNyRbuf5Nbs/Good_Father_Project.png" alt="The Good Father Project Logo" className="h-12 w-auto" data-id="element-31" />
        </div>

        <nav className="hidden md:flex items-center gap-8" data-id="element-32">
          <a href="#mission" className="text-[#2D2D2D] hover:text-[#3D5A4C] transition-colors font-medium" data-id="element-33">
            Mission
          </a>
          <a href="#how-it-works" className="text-[#2D2D2D] hover:text-[#3D5A4C] transition-colors font-medium" data-id="element-34">
            How It Works
          </a>
          <a href="#who-its-for" className="text-[#2D2D2D] hover:text-[#3D5A4C] transition-colors font-medium" data-id="element-35">
            Who It's For
          </a>
          <Button onClick={scrollToPartner} variant="primary" size="sm" data-id="element-36">
            Partner With Us
          </Button>
        </nav>

        {/* Mobile menu button placeholder - keeping it simple for now */}
        <button className="md:hidden text-[#2D2D2D]" onClick={scrollToPartner} data-id="element-37">
          Partner With Us
        </button>
      </Container>
    </header>;
}